module.exports = __webpack_public_path__ + "static/media/instagram.d9f7cc18.svg";